import * as ErrorConstants from "@/constants/error";

export function setError(error, requestType) {
  return {
    type: ErrorConstants.SET_ERROR,
    requestType,
    error
  };
}